import { DefaultService } from "@/api/SolarCloudApi";
import { v4 as uuid } from "uuid";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MutationConfig } from "@/lib/react-query";
import getNewOrderOptions from "./useNewOrder";

async function createNewOrder(panels = 0) {
  console.log("called create new order");
  const response = await DefaultService.newOrderGet(uuid(), panels);
  return response;
}

type UseCreateNewOrderOptions = {
  mutationConfig?: MutationConfig<typeof createNewOrder>;
};

export function useCreateNewOrder({
  mutationConfig,
}: UseCreateNewOrderOptions = {}) {
  const queryClient = useQueryClient();

  const { onSuccess, onError, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      try {
        queryClient.setQueryData(
          getNewOrderOptions(data.uuid!).queryKey,
          data
        );
      } catch (e) {
        queryClient.refetchQueries({
          queryKey: getNewOrderOptions(data.uuid!).queryKey,
        });
      }
      onSuccess?.(data, ...args);
    },
    onError: (error, ...args) => {
      console.error("Error creating new order:", error);
      onError?.(error, ...args);
    },
    ...restConfig,
    mutationFn: createNewOrder,
    retry: 1,
  });
}
